import Loading from 'components/GeneralComponents/Loading'
import ShowProjectReportCard from 'components/Projects/showProjectReportCard/ShowProjectReportCard'
import Axios from 'middleware/axiosInstance'
import React, { useEffect, useState } from 'react'
import "./ShowProjectReport.scss"

const ShowProjectReport = () => {

    const [projectReports, setProjectReports] = useState(null)

    const getProjectReport = () => {
        Axios.post(`show_project`, { "api_token": `${localStorage.getItem("token")}`, })
            .then((response) => {
                console.log(response)
                setProjectReports(response.data.reverse())
            })
            .catch((error) => {
                console.log(error)
            })
    }

    useEffect(() => {
        getProjectReport()
    }, []);

    return (
        <div className='allLeavesContainer'>
            {projectReports ?
                projectReports.map((report, index) => {
                    return <div key={index}> <ShowProjectReportCard report={report} index={index}/> </div>
                })
                : <Loading />}
        </div >
    )
}

export default ShowProjectReport